import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import HowToRegIcon from '@mui/icons-material/HowToReg';

const SmallModal = (props) => {
  const { select, children, setSelect, confirm, title } = props;


  return (
    <Dialog
      open={select}
      onClose={() => {
        setSelect(false);
      }}
      keepMounted
    // fullWidth={true}
    >
      <DialogTitle className="text-capitalize">
        {title ?? "Confirm Action"}
      </DialogTitle>
      <DialogContent>

        <Typography> {children}</Typography>

      </DialogContent>
      <DialogActions>
        <Button onClick={() => {
          setSelect(false);
        }} color={'error'}>No</Button>
        <Button onClick={() => {
          setSelect(false);
          confirm();
        }}><HowToRegIcon
          style={{ color: 'green' }}
         /> Yes</Button>
      </DialogActions>
    </Dialog>
  );
};
export default SmallModal;




